import client from './client';

// 백엔드 엔드포인트 URL 상수로 관리
const clientPerformanceUrl = '/api/v1/clientPerformanceStat';

/**
 * 🚀 [제공해주신 형태 반영] 특정 연도의 전사 고객사 실적 리스트 조회
 * @param {string} year 조회 대상 연도 (예: '2026')
 */
export const getPerformanceList = (year) => {
  return client.get(`${clientPerformanceUrl}/yearList`, {
    params: { year }
  });
};

export const getClientPerformanceDetail = (clientId, year) => {
  return client.get(`${clientPerformanceUrl}/${clientId}`, {
    params: { year } // 💡 URL 뒤에 ?year=2026 형태로 연도 구분이 자동으로 붙습니다.
  });
};